import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { Invoice } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-invoices-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './invoices-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InvoicesGridComponent extends BaseGridComponent {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private InvoiceService: InvoiceService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'Invoice';
    this.rowModelType = 'serverSide';

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.InvoiceService.getInvoices(queryObject),
          this.InvoiceService.getInvoiceCount(countQueryObject)
        ]).subscribe({
          next: ([Invoices, invoiceCount]) => {
            const successObject: {
              rowData: Invoice[];
              rowCount: number;
            } = {
              rowData: Invoices,
              rowCount: invoiceCount
            };

            params.success(successObject);
          },
          error: (error) => {
            params.fail();
          }
        });
      }
    };
  }
}
